<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading"><i class="fa fa-refresh fa-spin"></i></div>
    <b-modal title="Erro!" class="modal-danger" v-model="hasErrors" @ok="hasErrors = false"
      ok-variant="danger" ok-only>
      Verifique todos os campos e tente novamente.
    </b-modal>
    <b-modal title="Info!" class="modal-primary" v-model="notFound" @ok="notFound = false"
      ok-variant="primary" ok-only>
      Acompanhante não encontrado.
    </b-modal>
    <b-row>
      <b-col lg="12" v-if="!editOrder && !showGuests">
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> Acompanhante: {{ guest.passport_first_name }} {{ guest.passport_last_name }}
          </div>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Nome conforme passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.passport_first_name"
                    :class="{'is-invalid': $v.guest.passport_first_name.$invalid}" maxlength="50">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Sobrenome conforme passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.passport_last_name"
                    :class="{'is-invalid': $v.guest.passport_last_name.$invalid}" maxlength="50">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Número do passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.passport_number"
                    :class="{'is-invalid': $v.guest.passport_number.$invalid}" maxlength="50">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Nacionalidade">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.nacionality"
                    :class="{'is-invalid': $v.guest.nacionality.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="País de emissão">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.passport_authority"
                    :class="{'is-invalid': $v.guest.passport_authority.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Validade do passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.passport_validity" v-mask="'99/99/9999'"
                    :class="{'is-invalid': $v.guest.passport_validity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Nome de crachá">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.name"
                    :class="{'is-invalid': $v.guest.name.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Celular">
                <b-input-group>
                  <b-form-input type="text" v-mask="'(99) 99999-9999'" v-model="guest.cell_phone"
                    :class="{'is-invalid': $v.guest.cell_phone.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="CPF">
                <b-input-group>
                  <b-form-input type="text" v-mask="'999.999.999-99'" v-model="guest.cpf" @input="_updateMask"
                    :class="{'is-invalid': $v.guest.cpf.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="RG">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.rg"
                    :class="{'is-invalid': $v.guest.rg.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Validade do RG">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.validade_rg"
                    :class="{'is-invalid': $v.guest.validade_rg.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data de Nascimento">
                <b-input-group>
                  <b-form-input type="text" v-mask="'99/99/9999'" v-model="guest.date_of_birth"
                    :class="{'is-invalid': $v.guest.date_of_birth.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset
                label="Sexo"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group style="margin-top: 35px; margin-left: -45px;"
                  v-model="guest.gender"
                  :options="[
                    {text: 'Masculino', value: '1'},
                    {text: 'Feminino', value: '2'},
                  ]"
                  value="1">
                </b-form-radio-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Grau de parentesco">
                <b-form-select
                  :plain="true"
                  :options="kinship"
                  value="Selecione o grau"
                  v-model="guest.kinship">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Restrição alimentar">
                <b-form-select
                  :plain="true"
                  :options="foods"
                  value="Selecione o tipo"
                  v-model="guest.food_id">
                </b-form-select>

              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Descrição da restrição">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.other_food">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Necessidades Especiais">
                <b-form-select
                  :plain="true"
                  :options="pwdList"
                  value="Selecione o tipo"
                  v-model="guest.pwd_id">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Descrição da necessidade especial">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.other_pwd">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset
                label="Não possui passaporte?"
                :label-cols="1"
                :horizontal="false">
                  <b-form-checkbox value="1" v-model="guest.has_passport">
                  </b-form-checkbox>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              Anexo:
              <b-button variant="default" class="btn-sm" @click="downloadAttachment()">
                <i class="fa fa-download"></i>&nbsp; {{ guest.attachment_name }}
              </b-button>
            </b-col> -->
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.start_city"
                    :class="{'is-invalid': $v.guest.start_city.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de retorno">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.return_city"
                    :class="{'is-invalid': $v.guest.return_city.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Qtd de PTC's anteriores">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.ptc_count"
                    :class="{'is-invalid': $v.guest.ptc_count.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Observação">
                <b-input-group>
                  <b-form-textarea :rows="2" :max-rows="3" v-model="guest.observation">
                  </b-form-textarea>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              <b-form-fieldset
                label="Não possui visto americano??"
                :label-cols="1"
                :horizontal="false">
                  <b-form-checkbox value="1" v-model="guest.has_visa">
                  </b-form-checkbox>
              </b-form-fieldset>
            </b-col> -->
          </b-row>
          <!-- <b-row class="form-group">
            <b-col md="3" v-if="!guest.has_visa">
              <b-form-fieldset label="Validade do visto">
                <b-input-group>
                  <b-form-input type="text" v-model="guest.visa_validity" v-mask="'99/99/9999'"
                    :class="{'is-invalid': $v.guest.visa_validity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
          </b-row> -->
          <b-row class="form-group">
            <b-col md="3">
              <b-button variant="default" @click="back">
                <i class="fa fa-arrow-left"></i>&nbsp; Voltar
              </b-button>
              <b-button variant="primary" @click="update($v.guest.$invalid, $v.guest.$touch())">
                <i class="fa fa-check"></i>&nbsp; Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
    <order-list :participantId="guest.participant_id" :guestId="guest.id"></order-list>
  </div>
</template>

<script>

import AwesomeMask from 'awesome-mask';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import Order from '../../views/orders/List.vue';
import * as Helper from './../../methods/helpers';

export default {
  name: 'forms',
  directives: {
    'mask': AwesomeMask
  },
  components: {
    'order-list': Order
  },
  data () {
    return {
      cities: [],
      foods: [],
      pwdList: [],
      kinship: [],
      showDismissibleAlert: false,
      loading: false,
      hasErrors: false,
      notFound: false,
      editOrder: false,
      currentOrder: false,
      showGuests: false,
      guest: {
        id: false,
        name: '',
        cpf: '',
        rg: '',
        validade_rg: '',
        kinship: '',
        registration: '',
        cell_phone: '',
        date_of_birth: '',
        gender: '',
        // has_visa: false,
        // visaValidity: '',
        has_passport: false,
        confirmInfo: false,
        completed: false,
        food_id: '',
        other_food: '',
        ptc_count: '',
        participant_id: false,
        attachment_name: '',
        passport_first_name: '',
        passport_last_name: '',
        passport_number: '',
        nacionality: '',
        passport_validity: '',
        start_city: '',
        return_city: '',
        support_point: '',
        city_support_point: ''
      }
    }
  },
  mounted () {
    this.loading = true
    this.$http.get(`sync`)
      .then(response => {
        const data = response.data
        this.foods = data.foods.map(food => {
          return {value: food.id, text: food.name}
        })
        this.pwdList = data.pwd.map(pwd => {
          return {value: pwd.id, text: pwd.name}
        })
        this.kinship = Object.keys(data.kinship).map((objectKey, idx) => {
          return {value: objectKey, text: data.kinship[objectKey]}
        })
      })
    const userId = this.$router.history.current.params.id
    this.$http.get(`guests/${userId}`)
      .then(response => {
        this.guest = response.data.guest;
        this.guest.date_of_birth = Helper.formatDate(this.guest.date_of_birth)
        if (this.guest.passport_validity !== null) {
          this.guest.passport_validity = Helper.formatDate(this.guest.passport_validity);
        }
        // if (this.guest.visa_validity !== null) {
        //   this.guest.visa_validity = Helper.formatDate(this.guest.visa_validity)
        // }
        this.loading = false
        setTimeout(() => { this.$v.guest.$reset() }, 1000)
      })
      .catch((error) => {
        log.error(error);
        this.notFound = true
        this.loading = false
      })
  },
  methods: {
    back () {
      if (this.guest.participant_id !== false) {
        this.$router.push({
          name: 'Participante',
          params: {id: this.guest.participant.user_id, guests: true}
        })
      } else {
        this.$router.push({name: 'Participantes'})
      }
    },
    update (isInvalid, touched) {
      if (isInvalid === false) {
        this.loading = true
        let guest = this.guest
        if (guest.has_visa) {
          guest.visa_validity = null
        }
        this.$http.put(`guests/${this.guest.id}`, {guest: guest})
          .then(response => {
            this.loading = false
            this.$router.push({
              name: 'Participante',
              params: {id: this.guest.participant.user_id, guests: true, updatedGuest: true}
            })
          })
          .catch(response => {
            this.hasErrors = true
            this.loading = false
          })
      }
    },
    _updateMask () {
      this.guest.cpf = this.guest.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, `$1.$2.$3-$4`)
    },
    downloadAttachment () {
      this.loading = true;
      this.$http.get(`guests/${this.guest.id}/attachment`)
      .then(response => {
        const linkSource = `data:image/*;base64,${response.data.attachment_binary}`;
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = this.guest.attachment_name;
        downloadLink.click();
        this.loading = false;
      })
      .catch(() => {
        this.notFound = true;
        this.loading = false;
      })
    }
  },
  validations () {
    return {
      guest: {
        name: { required, maxLength: maxLength(23) },
        cell_phone: { minLength: minLength(15), maxLength: maxLength(15) },
        cpf: { minLength: minLength(14), maxLength: maxLength(14) },
        rg: { minLength: minLength(6), maxLength: maxLength(18) },
        validade_rg: { minLength: minLength(10), maxLength: maxLength(10) },
        kinship: { required },
        ptc_count: { required },
        date_of_birth: { required },
        gender: { required },
        observation: { maxLength: maxLength(200) },
        special_needs: { maxLength: maxLength(150) },
        // visa_validity: {
        //   required: requiredIf(function (guest) { return guest.has_visa === false }),
        //   isValidDate: function (value, guest) {
        //     return guest.has_visa === false ? Helper.isValidDate(value) : true
        //   }
        // },
        passport_first_name: !this.guest.hasPassport ? { required }: {},
        passport_last_name: !this.guest.hasPassport ? { required }: {},
        passport_number: !this.guest.hasPassport ? { required }: {},
        nacionality: { required },
        passport_authority: !this.guest.hasPassport ? { required }: {},
        passport_validity: !this.guest.hasPassport ? { required }: {},
        start_city: { required },
        return_city: { required },
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/guests/Edit.vue